import { render, staticRenderFns } from "./GetOrderHeadersEditOrder.vue?vue&type=template&id=70998f18&scoped=true&"
import script from "./GetOrderHeadersEditOrder.vue?vue&type=script&lang=js&"
export * from "./GetOrderHeadersEditOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70998f18",
  null
  
)

export default component.exports